import type { JSX } from 'react';

import { Box } from '@change-corgi/design-system-legacy/layout';

import type { ModalOptions, ModalOptionsDefault, ModalVariantProps } from '../../shared/types';
import { useModalZIndex } from '../../useModalZIndex';
import { ModalBody } from '../ModalBody';
import { ModalHeading } from '../ModalHeading';

export function FullPageModal<
	OPTIONS extends ModalOptions = ModalOptionsDefault,
	RESULT = undefined,
	STATE = undefined,
>({
	options,
	heading,
	title,
	body,
	closeModal,
	closeButton,
	onCloseButtonClick,
	persistentState,
	onPersistentStateUpdate,
	stylesOverrides,
	...props
}: ModalVariantProps<OPTIONS, RESULT, STATE>): JSX.Element {
	const modalZIndex = useModalZIndex();

	return (
		/* using top/bottom/right/left positioning instead of vw/vh because of scrolling issues on mobile */
		<Box
			sx={{
				paddingY: 16,
				paddingX: 16,
				backgroundColor: 'primary-white',
				color: 'typography-primary',
				position: 'fixed',
				zIndex: 'modal',
				top: 0,
				left: 0,
				bottom: 0,
				right: 0,
				overflowY: 'auto',
				overflowX: 'hidden',
				WebkitOverflowScrolling: 'touch',
				...stylesOverrides,
			}}
			{...props}
		>
			<ModalHeading
				options={options}
				title={title}
				heading={heading}
				closeModal={closeModal}
				modalZIndex={modalZIndex}
				closeButton={closeButton}
				onCloseButtonClick={onCloseButtonClick}
				persistentState={persistentState}
				onPersistentStateUpdate={onPersistentStateUpdate}
			/>
			<ModalBody
				options={options}
				body={body}
				closeModal={closeModal}
				modalZIndex={modalZIndex}
				persistentState={persistentState}
				onPersistentStateUpdate={onPersistentStateUpdate}
			/>
		</Box>
	);
}
